import * as type from '../actions/types';

const initialState = {
    loading: false,
    error: null,
    success: null,
}

export default function registerResendOtp(state = initialState, action) {
    switch (action.type) {
        case type.GET_REGISTER_RESEND_OTP_REQUESTED:
            return {
                ...state,
                loading: true,
                error: null, // Clear any previous errors when starting a new request
                success: null, // Clear any previous success messages
            }
        case type.GET_REGISTER_RESEND_OTP_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                success: action.message,
            }
        case type.GET_REGISTER_RESEND_OTP_FAILED:
            return {
                ...state,
                loading: false,
                error: action.message,
                success: null,
            }
        case type.CLEAR_REGISTER_RESEND_OTP_MESSAGES:
            return {
                ...state,
                error: null,
                success: null,
            }
        default:
            return state
    }
}